import {graphql, useLazyLoadQuery} from 'react-relay'

import {useAppSelector} from '../../../hooks/react-redux'
import useMyId from '../../../hooks/useMyId'
import {usePermission} from '../../../hooks/usePermission'
import {getBuildLocator} from '../../../rest/locators'
import {getBuild, getProjectIdFromBuildId} from '../../../selectors'
import {Permission} from '../../../types'
import type {BuildId} from '../../../types'

import type {StopBuildProjectIdQuery} from './__generated__/StopBuildProjectIdQuery.graphql'

const projectIdQuery = graphql`
  query StopBuildProjectIdQuery($buildLocator: String!, $skip: Boolean!) {
    build(buildLocator: $buildLocator) @skip(if: $skip) {
      buildType {
        project {
          id
        }
      }
    }
  }
`

export function useIsCancellable(buildId?: BuildId | null) {
  const projectIdFromStore = useAppSelector(state => getProjectIdFromBuildId(state, buildId))
  const {build} = useLazyLoadQuery<StopBuildProjectIdQuery>(projectIdQuery, {
    buildLocator: getBuildLocator(buildId),
    skip: projectIdFromStore != null,
  })
  const projectId = projectIdFromStore ?? build?.buildType?.project?.id
  const myId = useMyId()
  const isOthersPersonalBuild = useAppSelector(state => {
    const {personal, user} = getBuild(state, buildId) || {}
    return personal && (user?.id == null || user.id !== myId)
  })
  const canCancel = usePermission(Permission.CANCEL_BUILD, projectId)
  const canCancelAnyPersonalBuild = usePermission(Permission.CANCEL_ANY_PERSONAL_BUILD, projectId)
  return canCancel && (!isOthersPersonalBuild || canCancelAnyPersonalBuild)
}
